import { UrlSearchParams_append } from "../../common/urlUtils";

export type CompanyFilter = {
    searchText: string;

    pageSize: number;
    pageIndex: number;
};

const defaultPageIndex = 1 as const;
const defaultPageSize = 50 as const;

export function defaultCompanyFilter(initial: Partial<CompanyFilter> = {}): CompanyFilter {
    return {
        searchText: initial.searchText ?? "",
        pageSize: initial.pageSize ?? defaultPageSize,
        pageIndex: initial.pageIndex ?? defaultPageIndex,
    };
}

export function createCompanyFilterQueryParams(companyFilter: CompanyFilter): URLSearchParams {
    const queryParameters = new URLSearchParams();

    UrlSearchParams_append(queryParameters, "searchText", companyFilter.searchText);
    UrlSearchParams_append(queryParameters, "pageSize", companyFilter.pageSize);
    UrlSearchParams_append(queryParameters, "pageIndex", companyFilter.pageIndex);

    return queryParameters;
}